import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, Dice5 } from "lucide-react";
import { RegionService } from "../services/RegionService";
import { AudioTrack } from "../components/AudioTrack";
import "../styles/Region.css";
import {Toolbar} from "../components/Toolbar";
import { RegionData } from "../types/Types";

export const Region = () => {
  const { regionNameAlias } = useParams<{ regionNameAlias: string }>();
  const navigate = useNavigate();
  const [regionData, setRegionData] = useState<RegionData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      if (regionNameAlias) {
        const data = await RegionService.fetchRegionDetailsByAlias(
          regionNameAlias
        );
        setRegionData(data);
      }
      setLoading(false);
    };
    loadData();
  }, [regionNameAlias]);

  const handleRandomizeClick = () => {
    if (regionData && regionData.tracks) {
      const shuffled = [...regionData.tracks].sort(() => 0.5 - Math.random());
      setRegionData({ ...regionData, tracks: shuffled });
    }
  };

  if (loading) return <div className="region-loading">Loading...</div>;
  if (!regionData)
    return <div className="region-loading">Region not found.</div>;

  return (
    <div className="region-page-container">
      <Toolbar />
      <section className="inner-page-layout">
        <section className="inner-page-content">
          <button className="region-back-btn" onClick={() => navigate(-1)}>
            <ChevronLeft size={20} />
            Back
          </button>

          <div className="region-banner">
            <h1 className="region-name">{regionData.regionName}</h1>
            <h2 className="region-description">
              {regionData.trackCount} TRACKS
            </h2>
          </div>

          <button
            className="region-randomize-btn"
            onClick={handleRandomizeClick}
          >
            <Dice5 size={18} style={{ marginRight: "8px" }} />
            Randomize
          </button>

          <section className="tracks-container">
            {regionData.tracks?.map((track) => (
              <AudioTrack key={track.id} track={track} />
            ))}
          </section>
        </section>
      </section>
    </div>
  );
};
